import { Col, Row } from 'antd';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import FormInput from '../../../components/Inputs/FormInput';
import Paper from '../../../components/Paper/Paper';
import SaveCancelButtons from '../../Shipment/components/SaveCancelButtons';
import ClaimsSettingsTab from './ClaimsSettingsTabs/ClaimsSettingsTab';

const ClaimsSettingsScreen: FC = () => {
  const navigate = useNavigate();

  return (
    <Row className="h-100 overflow-hidden d-flex flex-direction-column flex-nowrap">
      <Col className="mb-10">
        <Paper className="p-10 border-radius-bottom-none">
          <Row align="middle" justify="space-between">
            <Col sm={12} md={6}>
              <FormInput
                name=""
                label="Initial Claim Number"
                placeholder="Enter initial claim number"
                singleLineMode
                margin="m-0"
                editMode
                colon
              />
            </Col>
            <Col>
              <SaveCancelButtons onCancel={() => navigate(-1)} idSuffix="shipment" />
            </Col>
          </Row>
        </Paper>
      </Col>
      <Col className="flex-1 custom-scroll-bar">
        <ClaimsSettingsTab />
      </Col>
    </Row>
  );
};

export default ClaimsSettingsScreen;
